import { jsx as _jsx } from "react/jsx-runtime";
import { Card } from 'antd';
import { BigAlert } from 'components/Alerts';
import DashboardPage from 'screens/DashboardScreen/components/DashboardPage';
const AlertPage = ({ title, header, children }) => (_jsx(DashboardPage, { title: title, children: _jsx(Card, { bordered: false, children: _jsx(BigAlert, { header: header, body: children }) }) }));
export default AlertPage;
